import React from "react";
import "./AboutMBR.css";

const AboutMBR = () => {
  return (
    <section className="about-mbr">
      <div className="about-content">
        <h2 className="h_about-heading">About MBR Network’s</h2>
        <p className="about-description">
          With over <b>5 years of real-time experience</b> in IT across diverse
          domains — from <b>Software Development</b> and{" "}
          <b>Business Development</b> to <b>Business Analysis</b> — I’ve learned
          what it truly takes to land a job and grow in today’s competitive
          world.
        </p>
        <p className="about-description">
          At <b>MBR Network’s</b>, my mission is simple yet powerful — to help
          <b> freshers and job seekers</b> break the struggle of unemployment.
          Through my{" "}
          <b>personal guidance, practical knowledge, and hands-on mentorship</b>
          , I ensure every student learns the right skills, gains confidence,
          and gets their <b>first job — without any compromise.</b>
        </p>
        <button className="learn-more-btn">Learn More</button>
      </div>
    </section>
  );
};

export default AboutMBR;
